import apple from '../../src/img/fruits/apple.png';
import bannana from '../../src/img/fruits/bannana.png';
import cherry from '../../src/img/fruits/cherry.png';
import grape from '../../src/img/fruits/grape.png';
import orange from '../../src/img/fruits/orange.png';
import strawberry from '../../src/img/fruits/strawberry.png';
import watermelon from '../../src/img/fruits/watermelon.png';
import pineapple from '../../src/img/fruits/pineapple.png';

export default [
  {id: 1, imgPath: apple},
  {id: 2, imgPath: bannana},
  {id: 3, imgPath: cherry},
  {id: 4, imgPath: grape},
  {id: 5, imgPath: orange},
  {id: 6, imgPath: strawberry},
  // {id: 8, imgPath: pineapple},
  // {id: 7, imgPath: watermelon},
];
